import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { createCampaign, detailCampaign, updateCampaign } from '../../../Context/api';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import axios from 'axios';
import { toast, } from 'react-toastify';

const UseAddCampaign = () => {
    const navigate = useNavigate()
    const [content, setContent] = useState({
        subject: '',
        template: ''
    });
    const [errors, setErrors] = useState({});

    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const editor = useRef(null);
    const { id } = useParams()
    // console.log(errors, 'errors')
    // console.log(content, 'content')
    useEffect(() => {
        if (id) {
            getCampaign()
        }
    }, [])

    const getCampaign = () => {
        axios.post(detailCampaign(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setContent((pre) => ({ ...pre, template: resp?.data?.data?.template, subject: resp?.data?.data?.subject }))
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const handleImageUpload = (files, insertImage) => {
        const uploadedImages = [];
        Array.from(files).forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64 = event.target.result; // Convert image to Base64
                uploadedImages.push(base64);
                insertImage(base64); // Insert the Base64 image into the editor
            };
            reader.readAsDataURL(file);
        });
    };
    const config = {
        uploader: {
            insertImageAsBase64URI: true, // Insert images directly into content
        },
        filebrowser: {
            uploadHandler: handleImageUpload, // Handle image uploads locally
        },
        toolbarAdaptive: false,
        toolbarSticky: false,
        buttons: "bold,italic,underline,|,image,link,|,ul,ol,|,undo,redo",
    };    
    const validateContent = () => {
        let newErrors = {};
        if (!content?.subject) {
            newErrors.subject = "Please enter subject";
        }
        if (!content?.template) {
            newErrors.template = "Please enter template";
        }

        setErrors(newErrors); // Update state with errors

        return Object.keys(newErrors).length === 0; // Return false if errors exist
    };
    const AddCampaign = () => {
        if (!validateContent()) return;
        const payload = {
            subject: content?.subject,
            template: content?.template,
            type: 'ADMIN',
            providerId: null
        }
        if (id) {
            payload.id = id
        }
        setSpinner(true)
        axios.post(id ? updateCampaign() : createCampaign(), { ...payload }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setSpinner(false)
                toast.success(resp.data.message)
                setTimeout(() => {
                    navigate(-1)
                }, 1000);
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const handleSave = () => {
        AddCampaign()
    };
    return {
        id,
        editor,
        spinner,
        errors,
        content,
        config,
        handleSave,
        navigate,
        setContent,
        setErrors,
        AddCampaign
    }
}

export default UseAddCampaign